export default "__VITE_ASSET__BRQXuNRQ__"